import { render, staticRenderFns } from "./JDList.vue?vue&type=template&id=63dd9833&scoped=true&"
import script from "./JDList.vue?vue&type=script&lang=js&"
export * from "./JDList.vue?vue&type=script&lang=js&"
import style0 from "./JDList.vue?vue&type=style&index=0&id=63dd9833&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63dd9833",
  null
  
)

export default component.exports